import { ComponentProps, ForwardedRef, forwardRef } from "react";

import { cn } from "@/utils/cn";

interface TextInputProps extends ComponentProps<"input"> {
  error?: boolean;
  errorMessage?: string;
}

const TextInput = forwardRef(function TextInput(
  { className, error, errorMessage, ...props }: TextInputProps,
  ref: ForwardedRef<HTMLInputElement>,
) {
  return (
    <div className="w-full">
      <input
        ref={ref}
        className={cn(
          "bg-input text-darkgray w-full rounded-lg px-3 py-2 font-pretendard outline-none",
          error && "border-red-500 focus:ring-red-500",
          className,
        )}
        {...props}
      />
      {error && errorMessage && <p className="mt-1 text-sm text-red-500">{errorMessage}</p>}
    </div>
  );
});

export default TextInput;
